window._ct_ = () => {};
function getSite(siteId) {
  var siteMap = {
    1: {
      lang: "en-GB",
      langCode: "en-GB",
      currency: "USD",
      shopId: "1",
    },
    2: {
      lang: "de-DE",
      langCode: "de-DE",
      currency: "EUR",
      shopId: "2",
    },
    3: {
      lang: "fr-FR",
      langCode: "fr-FR",
      currency: "EUR",
      shopId: "3",
    },
    4: {
      lang: "es-ES",
      langCode: "es-ES",
      currency: "EUR",
      shopId: "4",
    },
    5: {
      lang: "it-IT",
      langCode: "it-IT",
      currency: "EUR",
      shopId: "5",
    },
    6: {
      lang: "en-GB",
      langCode: "en-GB",
      currency: "AUD",
      shopId: "6",
    },
    7: {
      lang: "es-ES",
      langCode: "es-ES",
      currency: "EUR",
      shopId: "10",
    },
    8: {
      lang: "en-GB",
      langCode: "en-GB",
      currency: "GBP",
      shopId: "11",
    },
    9: {
      lang: "en-GB",
      langCode: "en-GB",
      currency: "CAD",
      shopId: "113",
    },
    14: {
      lang: "en-GB",
      langCode: "en-GB",
      currency: "NZD",
      shopId: "14",
    },
    21: {
      lang: "pl-PL",
      langCode: "pl-PL",
      currency: "PLN",
      shopId: "16",
    },
    22: {
      lang: "sv-SE",
      langCode: "sv-SE",
      currency: "SEK",
      shopId: "17",
    },
    24: {
      lang: "en-GB",
      langCode: "en-GB",
      currency: "SGD",
      shopId: "114",
    },
    26: {
      lang: "nl-BE",
      langCode: "nl-BE",
      currency: "EUR",
      shopId: "126",
    },
  };
  return siteId in siteMap ? siteMap[siteId] : siteMap["1"];
}

function extract(input) {
  const queryStart = input.indexOf("?");
  return queryStart === -1 ? "" : input.slice(queryStart + 1);
}
function parseUrl(url) {
  if (typeof url !== "string" || url.length === 0) return {};
  const queryString = extract(url);
  const kvs = queryString.split("&");
  return kvs
    .filter((t) => t)
    .reduce((queryObj, kv) => {
      let [key, val] = kv.split("=").map(decodeURIComponent);
      val = val.includes(",") ? val.split(",") : val;
      queryObj[key] = queryObj[key] ? [].concat(queryObj[key], val) : val;
      return queryObj;
    }, {});
}

var searchParams = parseUrl(window.location.href);
var siteId = searchParams["siteId"];
var siteObj = getSite(siteId);

window._cupshe_i18n_ = {};
window.cupshe_i18nReSet = () => {};
window._ct_ = (key = null, defaultValue = null) => {
  if (window && window._cupshe_i18n_ && window._cupshe_i18n_[key]) {
    return key
      ? window?._cupshe_i18n_[key]
        ? window?._cupshe_i18n_[key]
        : defaultValue
      : defaultValue;
  } else {
    return null;
  }
};
let i18nv = new Date().getTime();
let prod = "share-review.cupshe.com";
let env = "test";
// if (!__CUPSHE__?._I18N_OSS_PATH_) {

if (location.hostname === prod) {
  env = "prod";
}

let _I18N_OSS_PATH_ =
  env === "prod"
    ? "https://cdn-review.cupshe.com/i18n/web/"
    : env === "pre"
    ? "https://cs-oss-pre.oss-cn-hangzhou.aliyuncs.com/i18n/web/"
    : "https://cs-oss-release.oss-cn-hangzhou.aliyuncs.com/i18n/web/";
const fullPath = `${_I18N_OSS_PATH_}${siteId || 1}/i18n.js`;

// }
const src = `${fullPath}?version=${i18nv}`;
let i18nDom = document.createElement("script");
i18nDom.setAttribute("type", "text/javascript");
i18nDom.setAttribute("src", src);
if (i18nDom) {
  document.querySelector("head").appendChild(i18nDom);
  i18nDom.onload = () => {
    //  eslint-disable-next-line no-undef
    const lang = cupshe_i18n[siteObj.langCode];
    window._cupshe_i18n_ = lang || {};
    window.cupshe_i18nReSet({});
  };
}

window.addEventListener("load", function () {
  // 初始化多语言版本号
});
